import React from 'react'

// the intent of this is to be used to track whether a boolean value has changed at least once
// e.g., if we want to know if an api call has loaded once already, we call `const hasLoaded = useHasFlagChanged(isLoading)`
// it doesn't track the change until the flag changes to expectedValue, though
// so if it's false first and we expect it to change from true, then we wait for it to be true before checking if it changes back
export function useHasFlagChangedFrom({ flag, expectedStartValue }) {
  const hasChangedToExpectedState = React.useRef(false)
  const hasChanged = React.useRef(false)

  React.useEffect(() => {
    // already notified that it changed
    if (hasChanged.current) {
      return
    }

    // flag is now the value we expect it to start at
    if (!hasChangedToExpectedState.current && flag === expectedStartValue) {
      hasChangedToExpectedState.current = true
    }

    // flag has now changed to the expected value and back
    if (hasChangedToExpectedState.current && flag !== expectedStartValue) {
      hasChanged.current = true
    }
  }, [flag, expectedStartValue])

  return hasChanged.current
}
